import {
    Button, Card, Checkbox,
    Input, Spinner,
    Subtitle1,
    useId,
} from "@fluentui/react-components";
import {signInUserPasswordless, verifyOTP} from "../handlers/userhandler";
import {useState} from "react";

import {checkLoginPage, navigateToPage} from "../handlers/routehandler";
import Icon from "../assets/klokking-icon.png"
import {BiLeftArrowAlt, BiRightArrowAlt} from "react-icons/bi";
import MessageBox from "../components/MessageBar";
import {LoginStates} from "../enums/loginStates";

const LoginView = () => {
    const [errorMsg, setErrorMsg] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [loginState, setLoginState] = useState(LoginStates.EMAIL);
    const [acceptSignUp, setAcceptSignUp] = useState(false);
    const [email, setEmail] = useState("");
    const [otp, setOTP] = useState("");

    const emailId = useId("Email");
    const otpId = useId("Otp");

    checkLoginPage();

    async function emailClick() {
        setErrorMsg(null);
        setIsLoading(true);
        const result = await signInUserPasswordless(email, acceptSignUp);
        setIsLoading(false);

        if (result == null) {
            setLoginState(LoginStates.OTP);
        }

        setErrorMsg(result);
    }

    async function backToEmail() {
        setErrorMsg(null);
        setLoginState(LoginStates.EMAIL);
    }

    async function otpClick() {
        setErrorMsg(null);

        setIsLoading(true);
        const result = await verifyOTP(email, otp);
        setIsLoading(false);

        if (result == null) {
            navigateToPage(``);
        }

        setErrorMsg(result);
    }

    return (
        <div className={`login-container`}>
                <Card className={`inner-login-container`}>
                    {errorMsg != null ? <MessageBox intent={"error"} title={""} message={errorMsg} closeButtonFunction={() => {setErrorMsg(null)}}/> : null}
                    <div className={`flex flex-column flex-gap-small`}>
                        <div className={`flex flex-gap-small`}>
                            <img alt="Klokking Icon" src={Icon} className={`login-icon`} />
                            <div>
                                <div className={`flex flex-gap-small`}>
                                    <Subtitle1>Welcome to Klokking</Subtitle1>
                                    { isLoading && <Spinner size={`extra-small`}/> }
                                </div>
                                <p className={`text-no-margin`}>{ loginState === LoginStates.EMAIL ? `Enter an email address to sign in.` : `An email has been sent to ${email}.` }</p>
                            </div>
                        </div>
                    </div>
                    { loginState === LoginStates.EMAIL &&
                        <form className={`flex flex-column flex-gap-small`} onSubmit={emailClick}>
                            <Input type={`email`} id={emailId} placeholder="Email" className={`width-100`} onChange={(e) => setEmail(e.target.value)} />
                            <Checkbox label={`Allow creating new account`} checked={acceptSignUp} onChange={(e) => setAcceptSignUp(e.target.checked)} />
                            <div className={`flex flex-justify-end width-100`}>
                                <Button as={"button"} className={`button`} type={`submit`} appearance={`primary`} disabled={isLoading}>
                                    Sign in <BiRightArrowAlt/>
                                </Button>
                            </div>
                            <p className={`text-small text-no-margin text-center text-sub`}>When sending a token, you agree with the <a className={`text-no-margin`} href={`#/privacy`}>privacy policy.</a></p>
                        </form>
                    }
                    { loginState === LoginStates.OTP &&
                        <form className={`flex flex-column flex-gap-small`} onSubmit={otpClick}>
                            <Input type={`text`} id={otpId} placeholder="Token" className={`width-100`} onChange={(e) => setOTP(e.target.value)}/>
                            <div className={`flex flex-space-between width-100`}>
                                <Button as={`a`} className={`button`} appearance={`subtle`} onClick={backToEmail}>
                                    <BiLeftArrowAlt/> Change Email
                                </Button>
                                <Button as={"button"} className={`button`} type={`submit`} appearance={`primary`} disabled={isLoading}>
                                    Validate Token <BiRightArrowAlt/>
                                </Button>
                            </div>
                            <p className={`text-small text-no-margin text-center text-sub`}>Please note, the email will be sent from no-reply@gadijkhuis.nl</p>
                            <p className={`text-small text-no-margin text-center text-sub`}>If you don't receive an email, check also your spam folder.</p>
                        </form>
                    }

                </Card>
        </div>
    );
}

export default LoginView;